import {
  IconBookmark,
  IconBookmarkFilled,
  IconHeart,
  IconHeartFilled,
  IconPin,
  IconPinFilled,
  IconStar,
  IconStarFilled,
} from '@tock/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { IconSaveHeart, IconSavePin, IconSaveWant, IconStar as IconStarLegacy } from 'ui/icons';
import { PlaylistType } from 'utils/profileUtils';
import { Theme, css } from '@emotion/react';
import { makeStyles } from '@material-ui/core/styles';
import SvgIconFilledSaveHeart from 'ui/icons/IconFilledSaveHeart';
import SvgIconFilledSavePin from 'ui/icons/IconFilledSavePin';
import SvgIconFilledSaveWant from 'ui/icons/IconFilledSaveWant';
import SvgIconFilledStar from 'ui/icons/IconFilledStar';
import clsx from 'clsx';

interface GetPlaylistIconProps {
  playlistType: PlaylistType | undefined;
  filled?: boolean;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  starIcon: {
    color: theme.legacyColors.legacyDecorative12,
  },
  starIconFilled: {
    color: theme.legacyColors.legacyDecorative05,
  },
  heartIcon: {
    color: theme.legacyColors.legacyDecorative11,
  },
  wantToGoIcon: {
    color: theme.legacyColors.legacyDecorative15,
  },
}));

const PlaylistTypeIcon: React.FunctionComponent<GetPlaylistIconProps> = ({
  playlistType,
  filled,
  className,
}) => {
  const styles = useStyles();
  const getIcon = () => {
    switch (playlistType) {
      case 'WANT_TO_GO':
        return filled ? (
          <IconMigrationUtil
            legacyIcon={<SvgIconFilledSaveWant className={clsx(styles.wantToGoIcon, className)} />}
            newIcon={<IconBookmarkFilled className={clsx(styles.wantToGoIcon, className)} />}
          />
        ) : (
          <IconMigrationUtil
            legacyIcon={<IconSaveWant className={className} />}
            newIcon={
              <IconBookmark
                css={(theme: Theme) => css`
                  color: ${theme.legacyColors.legacyDecorative15};
                `}
                className={clsx(styles.wantToGoIcon, className)}
              />
            }
          />
        );
      case 'CUSTOM':
        return filled ? (
          <IconMigrationUtil
            legacyIcon={<SvgIconFilledSavePin className={clsx(className)} color="primary" />}
            newIcon={<IconPinFilled className={clsx(className)} />}
          />
        ) : (
          <IconMigrationUtil
            legacyIcon={<IconSavePin className={clsx(className)} color="primary" />}
            newIcon={<IconPin className={clsx(className)} />}
          />
        );
      case 'FAVORITE':
        return filled ? (
          <IconMigrationUtil
            legacyIcon={<SvgIconFilledSaveHeart className={clsx(styles.heartIcon, className)} />}
            newIcon={<IconHeartFilled className={clsx(styles.heartIcon, className)} />}
          />
        ) : (
          <IconMigrationUtil
            legacyIcon={<IconSaveHeart className={clsx(styles.heartIcon, className)} />}
            newIcon={
              <IconHeart
                css={(theme: Theme) => css`
                  color: ${theme.legacyColors.legacyDecorative11};
                `}
                className={className}
              />
            }
          />
        );
      case 'STAR':
      default:
        return filled ? (
          <IconMigrationUtil
            legacyIcon={<SvgIconFilledStar className={clsx(styles.starIconFilled, className)} />}
            newIcon={
              <IconStarFilled
                css={(theme: Theme) => css`
                  color: ${theme.legacyColors.legacyDecorative05};
                `}
                className={className}
              />
            }
          />
        ) : (
          <IconMigrationUtil
            legacyIcon={<IconStarLegacy className={clsx(styles.starIcon, className)} />}
            newIcon={
              <IconStar
                css={(theme: Theme) => css`
                  color: ${theme.legacyColors.legacyDecorative12};
                `}
                className={className}
              />
            }
          />
        );
    }
  };
  return <>{getIcon()}</>;
};

export default PlaylistTypeIcon;
